import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m4 5-.25-.25a1.06 1.06 0 0 1 1.5-1.5l15.5 15.5a1.06 1.06 0 0 1-1.5 1.5L14 15H4a1 1 0 1 1 0-2h8l-2-2H4a1 1 0 1 1 0-2h4L6 7H4a1 1 0 1 1 0-2m15 9a1 1 0 0 1-.293.707L17 13h1a1 1 0 0 1 1 1m-6-5a1 1 0 0 1 1 1zm7-2h-9L9 5h11a1 1 0 1 1 0 2"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3 18a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1" })
);
var SvgTranscriptionNokOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TranscriptionNokOutlined_default = SvgTranscriptionNokOutlined;

export { TranscriptionNokOutlined_default as default };
